import React, { FunctionComponent } from "react"
import { Table } from "react-bootstrap"
import TemplateManagementTableHeader from "./TemplateManagementTableHeader"
import TemplateManagementTableBody from "./TemplateManagementTableBody"
import "./TemplateManagementTable.css"

const TemplateManagementTable: FunctionComponent<{}> = () => {
    return (
        <div className="TemplateManagementTable">
            <Table id="template-management-table" bordered hover>
                <TemplateManagementTableHeader />
                <TemplateManagementTableBody />
            </Table>
        </div>
    )
}

export default TemplateManagementTable